import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import * as Sentry from "@sentry/capacitor";

// Action Types
export const UPDATE_EVENT_SUCCESS = "UPDATE_EVENT_SUCCESS";
export const UPDATE_EVENT_ERROR = "UPDATE_EVENT_ERROR";

// Thunk Action Creator
export const updateEventAction = createAsyncThunk(
    "api/Calendar/updateEvent",
    async (json, { dispatch }) => {

        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        try {
            const response = await axios.post(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/updateEvent`,
                {
                    Type: json.type,
                    CalendarId: json.calendarId,
                    EventId: json.eventId,
                    TaskId: json.taskId,
                    Color: json.color,
                    Title: json.title,
                    Start: json.start,
                    End: json.end,
                    TimeZone: timeZone,
                    AllDay: json.allDay ?? false
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )

            if (response.status === 200) {
                if (response.data === '') {
                    throw new Error("Problem updating an event. Logging the user out");
                } else {
                    dispatch({
                        type: UPDATE_EVENT_SUCCESS,
                        payload: response.data,
                    });
                }
            }
        }
        catch (error) {
            // Only capture client-side/network errors; server 500+ errors are already captured by CalendarController
            if (!error.response || error.response.status < 500) {
                Sentry.captureException(error, {
                    tags: {
                        error_type: 'calendar_event_update_failure',
                        operation: 'updateEvent',
                        calendar_type: json?.type,
                    },
                    level: 'error',
                    extra: {
                        status_code: error.response?.status,
                    }
                });
            }
            dispatch({ type: UPDATE_EVENT_ERROR, payload: error });
        }
    }
);
